import * as React from 'react';

import { useSelector } from 'react-redux';

import { QuizEditorEditableQuizTitle } from '~teacher/components/QuizEditor/QuizEditorHeader/QuizEditorEditableQuizTitle';
import { useWorkspaceQuizLock } from '~teacher/hook/workspaces/useWorkspaceQuizLock';
import { selectEditingQuiz } from '~teacher/slices/quiz/quizSelectors';

import { LockStatus } from '../../../../../api/workspaces/lock';

interface QuizEditorQuizTitleProps {
  quizTitle: string;
}

function QuizEditorQuizTitle({ quizTitle }: QuizEditorQuizTitleProps) {
  return (
    <div className="pl-6 py-3 m-0 overflow-hidden font-display text-lg md:text-xl leading-14 font-700 break-words w-full h-full pr-20 text-blue-800 outline-none border-0 rounded-4 resize-none transition duration-100 ease-linear">
      {quizTitle}
    </div>
  );
}

interface Props {
  workspaceId: string;
  workspaceQuizId: string;
  isControlsDisabled: boolean;
}

export function TitleOrEditQuizTitle({
  workspaceQuizId,
  workspaceId,
  isControlsDisabled,
}: Props) {
  const quizLockQuery = useWorkspaceQuizLock({ workspaceQuizId, workspaceId });
  const { name: quizTitle } = useSelector(selectEditingQuiz);
  if (
    quizLockQuery.isSuccess &&
    quizLockQuery.data.lockStatus === LockStatus.LockedByYou
  ) {
    return (
      <QuizEditorEditableQuizTitle isControlsDisabled={isControlsDisabled} />
    );
  }

  return QuizEditorQuizTitle({ quizTitle: quizTitle });
}
